import classNames from 'classnames';
import { Button, FlexContainer, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { supportEmail, supportLink, tdsLink } from 'config';
import { useDataActions, useTenancy } from 'state';
import styles from './TodoItemTenancyDepositRegistration.module.scss';
import { tenancyDepositStatusTypes } from '../../../../../config/types';

/**
 * TodoItemTenancyDeposit
 *
 * @return {JSX.Element}
 */
const TodoItemTenancyDepositRegistration = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storageActions = useDataActions();
  const tenancyDoc = useTenancy();

  const handlerRegisterTds = () => {
    setIsLoading(true);
    storageActions.tenancy
      .registerDeposit(tenancyDoc)
      .finally(() => setIsLoading(false));
  };

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemTenancyDeposit,
        className,
        TodoItemTenancyDepositRegistration.displayName
      )}
      column
      gap
    >
      {tenancyDepositStatusTypes.unregistered === tenancyDoc.depositStatus ? (
        <>
          <Txt bold>
            {tenancyDoc.tenantsDepositPaid
              ? '⚠️ Legally required'
              : '⚠️ Deposit is unpaid'}
          </Txt>
          <Txt regular>
            For a tenancy to be legally compliant the deposit needs to be
            registered in a government approved tenancy deposit scheme.
          </Txt>
          <Txt regular>
            Propa partners with TDS (TDS Custodial Ltd) to allow you to register
            the deposit and pay directly to TDS without any fees.
          </Txt>
          <a
            href={tdsLink}
            target="_blank"
            className={styles.ButtonLink}
            rel="noreferrer"
          >
            <Button success flex>
              What is TDS?
            </Button>
          </a>
          <Txt regular>Follow the steps below to complete:</Txt>
          <Txt regular>
            1. Ensure you have received the whole deposit amount before
            registering.
          </Txt>
          <Txt regular>2. Tap the register button below.</Txt>
          <Button
            flex
            success
            onClick={handlerRegisterTds}
            disabled={isLoading}
          >
            Register with TDS
          </Button>
        </>
      ) : tenancyDepositStatusTypes.inRegistration ===
        tenancyDoc.depositStatus ? (
        <>
          <Txt bold>⏳ Deposit is in registration</Txt>
          <Txt regular>
            Thank you for registering your deposit with TDS. In the next 15
            minutes you will receive an email confirmation.
          </Txt>
          <Txt regular>
            After you receive that email you can protect your deposit in the
            Deposit Protection task.
          </Txt>
        </>
      ) : tenancyDepositStatusTypes.registeredNotPaid ===
        tenancyDoc.depositStatus ? (
        <>
          <Txt bold>Deposit is registered 🎉</Txt>
          <Txt regular>
            Congratulations the deposit has been successfully registered with
            TDS.
          </Txt>
          <Txt regular>
            You can now complete the next todo which is to protect the deposit
            in a government approved scheme by paying it to TDS.
          </Txt>
        </>
      ) : tenancyDepositStatusTypes.inRegistration ===
        tenancyDoc.depositStatus ? (
        <>
          <Txt bold>Deposit is registered 🎉</Txt>
          <Txt regular>
            Congratulations the deposit has been successfully registered with
            TDS.
          </Txt>
          <Txt regular>
            You can now complete the next todo which is to protect the deposit
            in a government approved scheme by paying it to TDS.
          </Txt>
        </>
      ) : tenancyDepositStatusTypes.error === tenancyDoc.depositStatus ? (
        <>
          <Txt bold>⛔️ There was an error</Txt>
          <Txt regular>
            Please contact:{' '}
            <a href={supportLink} target="_blank" rel="noreferrer">
              {supportEmail}
            </a>
          </Txt>
        </>
      ) : null}
    </FlexContainer>
  );
};

TodoItemTenancyDepositRegistration.displayName =
  'TodoItemTenancyDepositRegistration';

export default observer(TodoItemTenancyDepositRegistration);
